import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid2,
  useMediaQuery,
  Snackbar,
  Avatar,
} from "@mui/material";
import { PictureAsPdf, Slideshow } from "@mui/icons-material";

const QuickLinks = () => {
  // URL for the PDF file
  const pdfUrl =
    "https://stllminsightdev.blob.core.windows.net/llminsightfiles/SST_LLM_Insight_Iaas.pdf";
  // "https://blobtimesheet.blob.core.windows.net/llminsight-docs/LLMInsightAI_deck.pdf";

  // URL for the PDF file
  const SaasUrl =
    "https://stllminsightdev.blob.core.windows.net/llminsightfiles/SST_LLM_Insight_Saas.pdf";

  // Blob URL for the PPT File
  const pptBlobUrl =
    "https://stllminsightdev.blob.core.windows.net/llminsightfiles/LLMinsight_SaaS_One_Pager_architecture.pdf";

  const azureUrl =
    "https://azuremarketplace.microsoft.com/en-us/marketplace/apps/shrisaitechllc1657565263846.constingapp?tab=Overview";

  const awsUrl = "https://aws.amazon.com/marketplace/pp/prodview-xlkqdas262mda";
  const gcpUrl =
    "https://console.cloud.google.com/marketplace/product/sst-public/llminsight.ai?";

  const [openSnackbar, setOpenSnackbar] = useState(false); // State to handle Snackbar
  const [provider, setProvider] = useState("AWS");

  const handleAzureClick = () => {
    window.open(azureUrl, "_blank");
  };

  // Show under development message on AWS card click
  const handleAwsClick = () => {
    window.open(awsUrl, "_blank");
    // setProvider("AWS");
    // setOpenSnackbar(true); // Open the snackbar with a message
  };

  // Show under development message on GCP card click
  const handleGoogleClick = () => {
    window.open(gcpUrl, "_blank");
    // setProvider("GCP");
    // setOpenSnackbar(true); // Open the snackbar with a message
  };

  const handleProvidersClick = () => {
    window.open("/providers", "_blank");
  };

  // Handle PDF card click
  const handlePdfClick = async (url) => {
    try {
      const response = await fetch(url, { method: "HEAD" });
      if (response.ok) {
        window.open(url, "_blank");
      } else {
        alert("Sorry, the PDF could not be opened.");
      }
    } catch {
      alert("An error occurred while trying to access the PDF.");
    }
  };

  // Function to download the PPT file
  const handleDownloadPpt = () => {
    fetch(pptBlobUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "one_pager.ppt"; // Desired download file name
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => console.error("Error downloading PPT file:", error));
  };

  // Media query to detect very large screens
  const isLargeScreen = useMediaQuery("(min-width:1600px)");

  return (
    <Box
      sx={{
        flexGrow: 1,
        width: "100%",
        paddingX: 2,
        justifySelf: "center",
      }}
    >
      <Typography
        sx={{
          color: "#002367",
          fontFamily: "Light",
          fontSize: { xs: 28, sm: 36, md: 42 }, // Responsive font size
          fontWeight: "700",
          lineHeight: "35px",
          textAlign: "center",
          marginTop: { xs: 6, sm: 2, md: 2, lg: 3, xl: 3 },
          marginBottom: { xs: 5, sm: 4, md: 4, lg: 6, xl: 6 },
        }}
      >
        Quick Links
      </Typography>
      <Grid2
        container
        spacing={3}
        justifyContent="center"
        sx={{
          maxWidth: isLargeScreen ? "1600px" : "100%",
          margin: "0 auto",
        }}
      >
        {/* PDF Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={() => handlePdfClick(pdfUrl)}
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <PictureAsPdf sx={{ fontSize: 40, color: "#D32F2F" }} />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 2,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                LLM Insight IaaS Deck
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* Vertext AI PDF Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={() => handlePdfClick(SaasUrl)}
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              {/* <PictureAsPdf sx={{ fontSize: 40, color: "#D32F2F" }} /> */}
              {/* <Avatar
                src={"/providers/vertex.png"}
                alt={""}
                sx={{
                  // maxWidth: "100%",
                  width: 45,
                  height: "auto",
                  objectFit: "contain",
                  justifySelf: "center",
                }}
              /> */}
              <PictureAsPdf sx={{ fontSize: 40, color: "#D32F2F" }} />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 2,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                LLM Insight SaaS Deck
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* PPT Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={() => handlePdfClick(pptBlobUrl)}
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <Slideshow sx={{ fontSize: 40, color: "#388E3C" }} />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 2,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                Download One Pager
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
        {/* LLM Providers Link Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={handleProvidersClick} // Show under development message on click
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <img
                src="/provider.png"
                alt="Provider Logo"
                style={{
                  maxWidth: "100%",
                  width: 60,
                  height: "auto",
                  opacity: 0.8,
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 1.5,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                LLM Providers List
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
        {/* Azure Link Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={handleAzureClick}
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <img
                src="/azure.png"
                alt="AI Icons"
                style={{
                  maxWidth: "100%",
                  width: 40,
                  height: "auto",
                  opacity: 0.8,
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 2,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                Get From Azure Market Place
                {""}
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* AWS Link Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={handleAwsClick} // Show under development message on click
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <img
                src="/aws.png"
                alt="AWS Logo"
                style={{
                  maxWidth: "100%",
                  width: 60,
                  height: "auto",
                  opacity: 0.8,
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 2.5,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                Get From AWS Market Place
              </Typography>
            </CardContent>
          </Card>
        </Grid2>

        {/* Google Link Card */}
        <Grid2 item xs={12} sm={6} md={4} lg={4} xl={4}>
          <Card
            onClick={handleGoogleClick} // Show under development message on click
            sx={{
              width: "280px",
              height: "130px",
              borderRadius: 3,
              border: "1px solid rgb(56, 55, 55, 0.2)",
              boxShadow: "0px 4px 10px rgba(0,0,0,0.15)",
              transition: "0.3s",
              "&:hover": {
                boxShadow: "2px 6px 25px rgba(0,0,0,0.2)",
                cursor: "pointer",
              },
              textAlign: "center",
              backgroundColor: "#FFFFFF",
              // mx: "auto",
              marginLeft: { xs: -1, sm: 0, md: 0, lg: 0, xl: 0 },
            }}
          >
            <CardContent>
              <img
                src="/gcp.png"
                alt="GCP Logo"
                style={{
                  maxWidth: "100%",
                  width: 60,
                  height: "auto",
                  opacity: 0.8,
                  objectFit: "contain",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontFamily: "Light",
                  fontSize: { xs: 14, sm: 16, md: 16, lg: 18, xl: 18 },
                  fontWeight: "500",
                  color: "#0A3161",
                  mt: 1.5,
                  wordWrap: "break-word",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                }}
              >
                Get From Google Cloud
              </Typography>
            </CardContent>
          </Card>
        </Grid2>
      </Grid2>

      {/* Snackbar for Under Development message */}
      <Snackbar
        open={openSnackbar}
        onClose={() => setOpenSnackbar(false)}
        message={
          provider === "AWS"
            ? "AWS Marketplace - Under Development"
            : "GCP - Under Development"
        }
        autoHideDuration={3000} // Message auto disappears after 3 seconds
      />
    </Box>
  );
};

export default QuickLinks;
